import React from 'react';
import {css} from 'emotion';
import LogoIes from '../images/logo-ies.png';
import LogoIes2x from '../images/logo-ies@2x.png';
import LogoIes3x from '../images/logo-ies@3x.png';
import CompuNegro from '../images/compu-negro.png';
import CompuNegro2x from '../images/compu-negro@2x.png';
import CompuNegro3x from '../images/compu-negro@3x.png';

const Footer = () => {
    return (
        <footer
            className={css`
                background-color: #fff;
                padding: 40px 40px 100px 40px;
                text-align: center;
                margin: 0;
                display:none;
            `}
        >
            <div
                className={css`
                    max-width: 150px;
                    margin: auto;
                `}
            >
                <img
                    src={CompuNegro}
                    srcSet={`${CompuNegro} 1x, ${CompuNegro2x} 2x, ${CompuNegro3x} 3x`}
                    alt="Compu"
                    className={css`
                        max-width: 150px;
                        width: 100%;
                    `}
                />
            </div>

            <div
                className={css`
                    max-width: 115px;
                    margin: auto;
                    margin-top: 48px;
                `}
            >
                <a  href="https://www.ies21.edu.ar" target="_blank" rel="noopener noreferrer">
                    <img
                        src={LogoIes}
                        srcSet={`${LogoIes} 1x, ${LogoIes2x} 2x, ${LogoIes3x} 3x`}
                        alt="IES"
                        className={css`
                            max-width: 115px;
                            width: 100%;
                        `}
                    />
                </a>
            </div>
        </footer>
    );
};

export default Footer;
